'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _ListView2 = require('./ListView');

var _ListView3 = _interopRequireDefault(_ListView2);

var DashboardView = (function (_ListView) {
    function DashboardView() {
        _classCallCheck(this, DashboardView);

        if (_ListView != null) {
            _ListView.apply(this, arguments);
        }
    }

    _inherits(DashboardView, _ListView);

    _createClass(DashboardView, [{
        key: 'setEntity',
        value: function setEntity(entity) {
            this.entity = entity;
            if (!this._name) {
                this._name = entity.name();
            }
            return this;
        }
    }]);

    return DashboardView;
})(_ListView3['default']);

exports['default'] = DashboardView;
module.exports = exports['default'];
//# sourceMappingURL=DashboardView.js.map


//////////////////
// WEBPACK FOOTER
// ./~/admin-config/lib/View/DashboardView.js
// module id = 47
// module chunks = 0